import styled from "styled-components";

export const HeroFavoriteContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
//   margin-top: 100px;     
  margin-bottom: 64px;  
//   padding: 0 0 0 100px; 

`;  

export const FavoriteImg= styled.img`
  width: 100%;
  height: auto;
border-radius:15px;
`;  